<script>
export default {
  name: 'Step',
  props: ['modelValue', 'name', 'value', 'disabled'],
  computed:{
    model:{
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      }
    }
  },
  methods: {
    isChecked(){
      return Array.isArray(this.model) ? this.model.indexOf(this.value) !== -1 : this.model
    }
  }
}
</script>

<template>
  <label :class="['toggle-slider', {'toggle-slider--disabled': disabled}]">
    <div :class="['switch', {'switch--checked':isChecked()}]">
      <input
          type="checkbox"
          :name="name"
          v-model="model"
          :value="value"
          :disabled="disabled"
      />
      <div class="slider"></div>
    </div>
    <div class="text">
      <slot></slot>
    </div>
  </label>
</template>

<style scoped lang="scss">
  @import '/src/style/variable';

  .toggle-slider {
    $width-slider: 22px;
    $padding: 5px;
    $correct-width: 0;
    @media #{$media-575}{
      $width-slider: 25px;
      $padding: 3px;
      $correct-width: 6px;
    }

    $width: calc(($width-slider + $padding) * 2 + $padding + $correct-width);
    $translate: translateX(calc($width - ($width-slider + $padding + $correct-width)));

    display: flex;
    align-items: center;
    &.toggle-slider--disabled {
      opacity: 0.5;
    }
    .text {
      font-size: 20px;
      font-weight: 600;
      color: $color-blue;
      font-family: $font-family;
      margin-left: 10px;
      @media #{$media-820}{
        font-size: 18px;
        width: 70%;
      }
      @media #{$media-575}{
        padding-left: 6px;
      }
    }
    .switch {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: $padding;
      width: $width;
      border-radius: 250px;
      border: 2px solid $color-navy-blue;
      background-color: $color-white;
      position: relative;
      input {
        display: none;
      }
      .slider {
        background-color: $color-navy-blue;
        transition: .4s;
        width: $width-slider;
        height: $width-slider;
        border-radius: 34px;
      }
      &--checked {
        border-color: $color-orange;
        background-color: $color-orange;
        .slider {
          background-color: $color-white;
          transform: $translate;
        }
        &+.text {
          color: $color-orange
        }
      }
    }
  }
</style>